import React from 'react';
import team15 from 'assets/img/team/20.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import Avatar from 'components/base/Avatar';
import { ProgressBar } from 'react-bootstrap';
import { Props } from './candidateProfile.type';

function CandidateProfile({ data }: Props) {
  return (
    <>
      <div className="d-flex flex-column align-items-center mb-4">
        <Avatar size="5xl" src={team15} className="mb-4" />
        <h4 className="mb-5">{data.username}</h4>
        <div className="mb-2">
          <p>
            <FontAwesomeIcon icon={faEnvelope} className="me-2" />
            <span>{data.email}</span>
          </p>
          <p>
            <FontAwesomeIcon icon={faPhone} className="me-2" />
            <span>{data.info.contactNumber}</span>
          </p>
        </div>
      </div>
      <div>
        <h4 className="border-bottom border-translucent border-dashed mb-4 pb-3">
          Skills
        </h4>
        <div>
          {Array.isArray(data.report) &&
            data.report.map((item, idx) => {
              return (
                <div key={idx}>
                  <p>{item.skill}</p>
                  <ProgressBar
                    variant="primary-lighter"
                    now={item.markRate}
                    className="mb-2"
                  />
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
}

export default CandidateProfile;
